/**
 * 名称验证器
 */
const nameValidator = (value) => {
    if (value.length < 3) return "Name must be at least 3 characters long";
    if (value.length > 20) return "Name must be less than 20 characters long";
    if (!/^[a-zA-Z ]+$/.test(value))
      return "Name must contain only letters and spaces";
    return false;
};

/**
 * Email验证器
 */
const emailValidator = (value, msg = "") => {
    if (!/^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/.test(value))
        return msg;
    return false;
};

/**
 * Email验证器
 */
const confirmEmailValidator = (originEmail, errorMsg) => {
    return (value, msg = "") => {
        if (!emailValidator(value, msg)) {
            if (originEmail !== value) {
                return errorMsg;
            }
            return false;
        } else {
            return emailValidator(value, msg);
        }
    };
};

/**
 * 空余验证起
 */
const emptyValidator = (value, msg = "") => {
    if (!value || value === "")
        return msg;
    return false;
};

export { nameValidator, emailValidator, emptyValidator, confirmEmailValidator };